var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.582053 13.9556C0.87308 13.9556 1.04123 13.8223 1.15117 13.5178L1.97251 11.2463H5.66532L6.49313 13.5178C6.60307 13.8223 6.77122 13.9556 7.06225 13.9556C7.39854 13.9556 7.6443 13.7462 7.6443 13.4543C7.6443 13.3719 7.6249 13.2767 7.57316 13.1371L4.56589 5.16791C4.4236 4.79356 4.19078 4.62225 3.83508 4.62225C3.45352 4.62225 3.21423 4.79991 3.07195 5.17426L0.0711398 13.1371C0.0194018 13.2767 0 13.3719 0 13.4543C0 13.7462 0.245756 13.9556 0.582053 13.9556ZM2.30881 10.2755L3.80275 6.10061H3.84155L5.33549 10.2755H2.30881Z",
    fill: "var(--klothed-textColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40663 14C9.84317 14 10.0954 13.8001 10.2603 13.3433L11.4923 9.9361H17.0315L18.2732 13.3433C18.4382 13.8001 18.6904 14 19.1269 14C19.6314 14 20 13.6859 20 13.2481C20 13.1244 19.9709 12.9816 19.8933 12.7723L15.3824 0.818491C15.169 0.256968 14.8197 0 14.2862 0C13.7138 0 13.3549 0.266485 13.1415 0.828008L8.64026 12.7723C8.56265 12.9816 8.53355 13.1244 8.53355 13.2481C8.53355 13.6859 8.90218 14 9.40663 14ZM11.9968 8.47995L14.2377 2.21754H14.2959L16.5368 8.47995H11.9968Z",
    fill: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAa);
export default __webpack_public_path__ + "static/media/aa.21e63826638b5519616912b6f70ecd05.svg";
export { ForwardRef as ReactComponent };